import { IconButtonSize } from '@/ui/atoms/icon-button/IconButton'

const sizes = {
  small: 40,
  medium: 48,
}

export const getButtonSize = (size: IconButtonSize = IconButtonSize.medium) =>
  sizes[size]
